
  const blueBelt = document.getElementById('projects-blue-belt');
  const scrollThreshold = 100;
  function handleScroll() {
  if (window.scrollY > scrollThreshold) {
  blueBelt.classList.add('scrolled');
} else {
  blueBelt.classList.remove('scrolled');
}
}
  window.addEventListener('scroll', handleScroll);
  document.addEventListener('DOMContentLoaded', handleScroll);
